import { handleActions } from 'redux-actions';
import {
  fetchUserSessionsRequest,
  fetchUserSessionsSuccess,
  fetchUserSessionsFailure,
  revokeSessionRequest,
  revokeSessionSuccess,
  revokeSessionFailure,
  revokeAllOtherSessionsRequest,
  revokeAllOtherSessionsSuccess,
  revokeAllOtherSessionsFailure,
} from './SessionsActions';

const initialState = {
  sessions: [],
  loading: false,
  error: null,
  revoking: {}, // Track which sessions are being revoked
  revokingAll: false,
};

export default handleActions(
  {
    [fetchUserSessionsRequest]: state => ({
      ...state,
      loading: true,
      error: null,
    }),

    [fetchUserSessionsSuccess]: (state, { payload }) => ({
      ...state,
      sessions: payload || [],
      loading: false,
      error: null,
    }),

    [fetchUserSessionsFailure]: (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload,
    }),

    [revokeSessionRequest]: (state, { payload: { sessionId } }) => ({
      ...state,
      revoking: {
        ...state.revoking,
        [sessionId]: true,
      },
    }),

    [revokeSessionSuccess]: (state, { payload: { sessionId } }) => ({
      ...state,
      revoking: {
        ...state.revoking,
        [sessionId]: false,
      },
      // Remove the revoked session from the list
      sessions: state.sessions.map(session =>
        session._id === sessionId ? { ...session, isActive: false } : session,
      ),
    }),

    [revokeSessionFailure]: (state, { payload: { sessionId, error } }) => ({
      ...state,
      revoking: {
        ...state.revoking,
        [sessionId]: false,
      },
      error,
    }),

    [revokeAllOtherSessionsRequest]: state => ({
      ...state,
      revokingAll: true,
      error: null,
    }),

    [revokeAllOtherSessionsSuccess]: state => ({
      ...state,
      revokingAll: false,
      error: null,
    }),

    [revokeAllOtherSessionsFailure]: (state, { payload }) => ({
      ...state,
      revokingAll: false,
      error: payload,
    }),
  },
  initialState,
);

// Selectors
export const getSessions = state => state.sessions?.sessions || [];
export const getSessionsLoading = state => state.sessions?.loading || false;
export const getSessionsError = state => state.sessions?.error;
export const getRevokingStatus = sessionId => state =>
  state.sessions?.revoking?.[sessionId] || false;
export const getRevokingAllStatus = state => state.sessions?.revokingAll || false;
